module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYBAMAAAAIZcBFAAAAG1BMVEUAAAAkMUkuLkYlL0MlLkIkL0IkL0IkLkEkLkKL5uDfAAAACHRSTlMAFRa0tcTU8rgkvYUAAAAySURBVBjTY2BAA6IOMBZjRgCMKdYmABdMpJKgeAcUOCCYBsgKkLRRSxjuIQZVA1RvAwDemBbrRkCpUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/nav/backUrl.png
// module id = tS9P
// module chunks = 16